import { isDevelopment } from '@rst/libs-ts'

export const ImportFontDev = () => {
	import('./atoms/fonts/inter/inter.css')
}

export * from './atoms'
export * from './molecules'
export * from './form'
export * from './organisms'
export * from './modal2'
export * from './libs'
